import React from 'react';
import "./projects.css";
import Img1 from '../../assets/html-css-javascript.jpg'
import Img2 from '../../assets/visual-studio-logo.jpeg'
import Img3 from '../../assets/eclipse.jpg' 
import Img4 from '../../assets/react.jpg' 
import Img5 from '../../assets/angular2.png'
 

const Projects = () => {
  return (
    <section id='projects'> 
    <br/>
    <h2>Projects</h2>

    <div className='container project_container'>
      <article className='project_item'>
        <div className='project_item-image'>
          <img src={Img1} alt=""/>
        </div>
        <h3>Compass Game</h3>
        <div className='project_item-cta'>
          <a href="https://github.com/snowhite414/Compass-Game" className='btn' target='_blank'>Github</a>
          <a href="https://snowhite414.github.io/Compass-Game/" className='btn btn-primary' target="_blank">Live Demo</a>
        </div>
      </article>
      <article className='project_item'>
        <div className='project_item-image'>
          <img src={Img2} alt=""/>
        </div>
        <h3>Course Registration <br></br> ASP .Net Core MVC</h3>
        <div className='project_item-cta'>
          <a href="https://github.com/snowhite414/CourseRegistration" className='btn' target='_blank'>Github</a>

        </div>
      </article>
      <article className='project_item'>
        <div className='project_item-image'>
          <img src={Img3} alt=""/>
        </div>
        <h3>Java Projects</h3>
        <div className='project_item-cta'>
          <a href="https://github.com/snowhite414/Java-Projects" className='btn' target='_blank'>Github</a>

        </div>
      </article>
      <article className='project_item'>
        <div className='project_item-image'>
          <img src={Img2} alt=""/>
        </div>
        <h3>Restaurant - Rest API</h3>
        <div className='project_item-cta'>
          <a href="https://github.com/snowhite414/Restaurant" className='btn' target='_blank'>Github</a>

        </div>
      </article>
      <article className='project_item'>
        <div className='project_item-image'>
          <img src={Img4} alt=""/>
        </div>
        <h3>eCommerce</h3>
        <div className='project_item-cta'>
          <a href="https://github.com/snowhite414/eCommerce" className='btn' target='_blank'>Github</a>
          <a href="https://ecommerce-hazel-cruz.netlify.app" className='btn btn-primary' target='_blank'>Live Demo</a>

        </div>
      </article>
      <article className='project_item'>
        <div className='project_item-image'>
          <img src={Img5} alt=""/>
        </div>
        <h3>To-do List</h3>
        <div className='project_item-cta'>
          <a href="https://github.com/snowhite414/To-do-List" className='btn' target='_blank'>Github</a>
          <a href="https://to-do-list-hazel-cruz.netlify.app/"  className='btn btn-primary' target='_blank'>Live Demo</a>
      </div>
      </article>
    </div>
    </section>
  )
}

export default Projects